import styled from "styled-components";

interface ChartsProps {
  $statusLabel?: string;
}

export const Charts = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  gap: 8px;
  justify-content: center;
  align-items: center;
`;

export const ChartTit = styled.div`
  color: ${(props) => props.theme.colors.text2};
  font-size: 1.2rem;
  font-weight: 400;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 4px;
`;

export const TitBox = styled.div`
  font-size: 12px;
  font-weight: 400;
  letter-spacing: -0.48px;
  position: relative;
  white-space: nowrap;
  width: fit-content;
`;

export const StatusBox = styled.div<ChartsProps>`
  display: inline-flex;
  background-color: ${(props) =>
    props.$statusLabel === "정상"
      ? props.theme.colors.green100
      : props.$statusLabel === "주의"
      ? props.theme.colors.yellow100
      : props.$statusLabel === "위험" && props.theme.colors.red100};
  color: white;
  font-size: 1rem;
  font-weight: 700;
  padding: 2px 4px;
  border-radius: 3px;
  position: relative;
  line-height: normal;
`;
